import "./nestedCheckbox.scss";

import { Checkbox, FormControlLabel } from "@mui/material";

import { Accordion } from "react-bootstrap";
import React from "react";
import { useTranslation } from "react-i18next";
const NestedCheckbox = (props) => {
  const { t } = useTranslation();
  let { handleChange, permissionsList, formik, component } = props;

  const handleCheckbox = (formik) => {
    formik.setFieldValue("claims", [...permissionsList]);
  };

  const nesting = (item) => {
    return item?.map((ele, index) => {
      if (ele.hasOwnProperty("sub") && ele?.sub?.length) {
        return (
          <>
            <Accordion className="custom-accordion">
              <Accordion.Item
                eventKey={index}
                style={{ border: index !== 0 && "none !important" }}
              >
                <Accordion.Header>
                  <div
                    className="d-flex"
                    key={ele?.translatedValue}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <div className="d-flex w-100 justify-content-between align-items-start">
                      <FormControlLabel
                        className="p-checkbox label-color"
                        label={t("permissions-list." + ele?.translatedValue)}
                        control={
                          <Checkbox
                            style={{ color: "#6200ee" }}
                            checked={ele?.value}
                            indeterminate={ele?.all === "mid"}
                            onChange={(event) => {
                              event.stopPropagation();
                              handleChange(event, ele);
                              if (component === "claims info")
                                handleCheckbox(formik);
                            }}
                            disabled={ele.disabledProduct}
                            disableRipple
                            disableFocusRipple
                          />
                        }
                      />
                    </div>
                  </div>
                  <hr className="horizentalLine" />
                </Accordion.Header>
                <Accordion.Body>{nesting(ele.sub)}</Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </>
        );
      }
      return (
        <>
          <div
            className="d-flex single-claim border-0"
            key={ele?.translatedValue}
          >
            <div className="d-flex w-100 justify-content-between align-items-start">
              <FormControlLabel
                className="p-checkbox label-color"
                label={t("permissions-list." + ele?.translatedValue)}
                control={
                  <Checkbox
                    style={{ color: "#6200ee" }}
                    disabled={ele.disabledProduct}
                    checked={ele?.value}
                    indeterminate={ele?.all === "mid"}
                    onChange={(event) => {
                      event.stopPropagation();
                      handleChange(event, ele);
                      if (component === "claims info") handleCheckbox(formik);
                    }}
                  />
                }
              />
            </div>
          </div>
        </>
      );
    });
  };
  return (
    <>
      {nesting(permissionsList)}

      {component === "claims info" &&
        formik.errors.claims &&
        formik.touched.claims && (
          <p style={{ color: "red", fontSize: "12px" }}>
            {formik.errors.claims}
          </p>
        )}
    </>
  );
};

export default NestedCheckbox;
